// TODO: cover with test using real API to make sure that ids are the same with backend
export const MINISITE_FILTER_KEY = 'siteId';

export const PAGE_TYPE = {
  CONTENT: {
    id: '5e97166e860488443057f765',
    name: 'Content Page',
  },
  LANDING: {
    id: '5e97166e860488443057f766',
    name: 'Landing Page',
  },
  COMPETITION_LANDING: {
    id: '5e97166e860488443057f767',
    name: 'Competition Landing Page',
  },
  MINISITE_LANDING: {
    id: '5e97166e860488443057f768',
    name: 'Minisite Landing Page',
  },
  MINISITE: {
    id: '5e97166e860488443057f769',
    name: 'Minisite Page',
  },
};

export const PAGE_TYPE_ID_TO_SUFFIX = {
  [PAGE_TYPE.CONTENT.id]: 'content',
  [PAGE_TYPE.LANDING.id]: 'landing',
  [PAGE_TYPE.COMPETITION_LANDING.id]: 'competition-landing',
  [PAGE_TYPE.MINISITE_LANDING.id]: 'minisite-landing',
  [PAGE_TYPE.MINISITE.id]: 'minisite',
};

export const FILTER_OPTION = {
  ALL: {
    key: '',
    label: 'All pages',
  },
  COMPETITION_LANDING_PAGES: {
    key: 'competition_landing_pages',
    label: 'Competition landing pages',
  },
  COMPETITION_PAGES: {
    key: 'competition_pages',
    label: 'Competition pages',
  },
  CONTENT_PAGES: {
    key: 'content_pages',
    label: 'Content pages',
  },
  LANDING_PAGES: {
    key: 'landing_pages',
    label: 'Landing pages',
  },
  PAGES_WITH_LIVE_BLOGS: {
    key: 'pages_with_live_blogs',
    label: 'Pages with live blogs',
  },
  MINISITE_LANDING_PAGES: {
    key: 'minisite_landing_pages',
    label: 'Minisite landing pages',
  },
  MINISITE_PAGES: {
    key: 'minisite_pages',
    label: 'Minisite pages',
  },
};

export const FILTER_OPTIONS = Object.values(FILTER_OPTION);

export const MAP_FILTER_OPTION_TO_API = {
  [FILTER_OPTION.ALL.key]: {},
  [FILTER_OPTION.COMPETITION_LANDING_PAGES.key]: {
    typeId: PAGE_TYPE.COMPETITION_LANDING.id,
  },
  [FILTER_OPTION.CONTENT_PAGES.key]: {
    typeId: PAGE_TYPE.CONTENT.id,
  },
  [FILTER_OPTION.LANDING_PAGES.key]: {
    typeId: PAGE_TYPE.LANDING.id,
  },
  [FILTER_OPTION.COMPETITION_PAGES.key]: {
    competitionPage: true,
  },
  [FILTER_OPTION.PAGES_WITH_LIVE_BLOGS.key]: {
    liveBlog: true,
  },
  [FILTER_OPTION.MINISITE_LANDING_PAGES.key]: {
    typeId: PAGE_TYPE.MINISITE_LANDING.id,
  },
  [FILTER_OPTION.MINISITE_PAGES.key]: {
    typeId: PAGE_TYPE.MINISITE.id,
  },
};

// FIXME: same with live blogs
export const DATE_FILTER = {
  ALL_TIME: 0,
  THIS_WEEK: 1,
  TODAY: 2,
  LAST_HOUR: 3,
};

export const DATE_OPTION = {
  ALL: {
    key: DATE_FILTER.ALL_TIME,
    label: 'All time',
  },
  THIS_WEEK: {
    key: DATE_FILTER.THIS_WEEK,
    label: 'This week',
  },
  TODAY: {
    key: DATE_FILTER.TODAY,
    label: 'Today',
  },
  LAST_HOUR: {
    key: DATE_FILTER.LAST_HOUR,
    label: 'Last hour',
  },
};
export const DATE_OPTIONS = Object.values(DATE_OPTION);
